module.exports = __webpack_public_path__ + "static/media/id5-casa_correia_de_sa.3d3ce55a.jpg";